module.exports = __webpack_public_path__ + "img/tower-dropper-screenshot.3b9bf4b6.webp";